import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  CardTitle,
  Form,
  FormGroup,
  FormText,
  Input,
  Table,
  Row,
  Col,
  Progress
} from "reactstrap";

import axios from "axios";

import { Redirect } from "react-router-dom";

import { PanelHeader, Button } from "components";

import { theadmobiles, tbody } from "variables/general";
import SweetAlert from "react-bootstrap-sweetalert";
import { Link } from "react-router-dom";
// react plugin used to create charts
import { Line } from "react-chartjs-2";
import { dashboardPanelChart } from "variables/charts.jsx";

var dashboardOrdersTitleStyle = 
{
  margin:"0 0 20px 20px", 
  color: "#FFF"
};

class MobileList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      downloading: {},
      showDetail: false,
      orderDetail: null,
      ordersChartReady: false,
      ordersHistoryTitle: "Histórico de facturas",
      toDashboard: false,
      searchQuery: ""
    };
    ////console.log(props);
    this.viewOrderArticles = this.viewOrderArticles.bind(this);
    this.searchMobiles = this.searchMobiles.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.createServicesButtons = this.createServicesButtons.bind(this);
    this.redirectTo = this.redirectTo.bind(this);
  }
  searchMobiles() {
    if (!this.props.mainState.isSearchingMobiles)
      this.props.getCustomersMobiles(this.state.searchQuery, null, null, true);
  }
  downloadBill(url, orderNumber, event){
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  hideAlert() {
    this.setState({
      alert: null
    });
  }
  goToDashboard() {
    this.setState({
      toDashboard: true
    });
  }
  paymentStatus(payment){
    let statusReady = null;
    if(payment.includes("Pendiente")){
      statusReady =                   
      <Button
        color="danger"
        size="sm"
      >
        <i className="now-ui-icons ui-1_simple-remove" /> {payment}
      </Button>;  
    } else{
      statusReady =                   
      <Button
        color="primary"
        size="sm"
      >
        <i className="now-ui-icons ui-1_check" /> {payment}
      </Button>;  
    }

    return statusReady;
  }
  downloadButton(order){
    let button = 
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if(this.state[order]){
      button = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  handleChange(field, event) {
    ////////console.log("Field name: " + field);
    ////////console.log("Field value: " + event.target.value);
    this.setState({ [field]: event.target.value });
  }
  viewOrderArticles(order){
    let orderDetailContent =
      <div>
        <Table responsive>
          <thead>
            <tr className="text-primary">
              <th className="text-center">
                Concepto
              </th>
              <th className="text-center">
                Precio
              </th>     
            </tr>
          </thead>
          <tbody>
            {this.props.mainState.ordersArticles[order].map((article, key) => {
              return (
                <tr key={key}>
                  <td className="text-center">{article.titulo}</td>
                  <td className="text-center">{article.total}</td>
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>;
    this.setState({
      orderDetail: orderDetailContent,
      showDetail: true
    })
  }
  createServicesButtons(customer) {
    let buttons = undefined;
    if (!this.props.mainState.customersMobilesLoaded) {
      buttons = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>
      </Button>
    } else {
      let mobilesQuantity = 0;
      if (customer.id in this.props.mainState.customersMobiles) {
        mobilesQuantity = this.props.mainState.customersMobiles[customer.id].length;
      }

      buttons = 
      <Button
        color={(mobilesQuantity > 0) ? "primary" : "default"}
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons tech_mobile" /> {mobilesQuantity}
        </div>
      </Button>      
    }
    
    return buttons;
  }
  createActiveCustomerButton(customer) {
    let button = undefined;
    if (customer.renovar_activo === "1") {
      button = 
      <Button
        color="primary"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons ui-1_check" /> Activo
        </div>
      </Button>
    } else {
      button = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons media-1_button-pause" /> Inactivo
        </div>
      </Button>
    }
    
    return button;
  }
  remainingUsage(usage, type, maxUsage) {
    let remainingUsage = 0;
    maxUsage = parseFloat(maxUsage);
    switch (type) {
      case "Llamadas":
        remainingUsage = maxUsage - Math.ceil(usage / 60);
        break;
      case "Datos":
        remainingUsage = (maxUsage * 1024 - usage / (1024 * 1024)) / 1024;
        break;
    }
    return remainingUsage;
  }
  getMaxUsageByType(mobile, currentDescription) {
    switch (currentDescription) {
      case "Llamadas":
        return parseFloat(mobile.minutos);
      case "Datos":
        return parseFloat(mobile.gigas);
      default:
        return 0;
    }
  }
  getRemainingUsageTextByType(remainingUsage, currentDescription) {
    switch (currentDescription) {
      case "Llamadas":
        return (
          <div style={{textAlign:"inherit"} /*{textAlign:"center", lineHeight: "17px"}*/}>
            {/*<span style={{fontSize:10}}>Quedan</span><br />*/}
            <span style={{fontSize:14, fontWeight:"bold"}}>{Math.round(remainingUsage).toLocaleString(navigator.language, { minimumFractionDigits: 0 })}<span style={{fontSize:10}}> minutos</span></span>
          </div>
        );
      case "Datos":
        remainingUsage = String(remainingUsage);
        if (!remainingUsage.includes("."))
          remainingUsage = remainingUsage + ".00";
        remainingUsage = remainingUsage
          .substring(
            0,
            remainingUsage.indexOf(".") > 0
              ? remainingUsage.indexOf(".") + 3
              : remainingUsage.length
          )
          .replace(".", ",");
        return (
          <div style={{textAlign:"inherit"} /*{textAlign:"center", lineHeight: "17px"}*/}>
            {/*<span style={{fontSize:10}}>Quedan</span><br />*/}
            <span style={{fontSize:14, fontWeight:"bold"}}>{remainingUsage}<span style={{fontSize:10}}> GB</span></span>
          </div>
        );
      default:
        return 0;
    }
  }
  createUsage(mobile) {
    // console.log("################## LOAD USAGE ON LIST ################");
    // console.log(mobile);
    let usageCreated = null;
    let gigasString = "";
    try {
      gigasString = mobile.gigas ? mobile.gigas.replace(".000", "") : "";
    } catch (error) {
      console.log("Error al leer los gigas de la tarifa del móvil " + mobile.numero);
      console.log(mobile.gigas);
    } 
    let gigasInt = parseInt(gigasString);

    if (mobile.numero in this.props.mainState.mobilesCDR) {
      //console.log("################## LOAD USAGE " + this.props.match.params.mobileNumber + " ################");
      //console.log(this.props.mainState.mobilesCDR);
      let CDR = this.props.mainState.mobilesCDR[mobile.numero];
      let dataUsage = undefined;
      if (mobile.gigas > 0) {
        let currentCDRType = "Datos";
        let currentCDR = CDR[currentCDRType];
        let usage = 0.0;
        if (currentCDR !== undefined) {
          usage = currentCDR[0].consumo;
        }
        if (parseInt(mobile.numero) in this.props.mainState.todayDataUsage) {
          let todayUsage = this.props.mainState.todayDataUsage[parseInt(mobile.numero)];
          // console.log("################## TODAY USAGE IN MOBILE NUMBER ################");
          // console.log(todayUsage);
          if (!todayUsage) {
            todayUsage = [];
          } else {
            // usage = 0.0;
          }
          try {
            todayUsage.map(todayUsageElemen => {
              usage += parseInt(todayUsageElemen.trafficUnits);
            });
          } catch (error) {}
        }
        let maxUsage = this.getMaxUsageByType(mobile, currentCDRType);
        let remainingUsage = this.remainingUsage(usage, currentCDRType, maxUsage);
        let usageText = this.getRemainingUsageTextByType(remainingUsage, currentCDRType);
        let barColor = (remainingUsage/maxUsage > 0.75) ? "primary" : (remainingUsage/maxUsage > 0.25) ? "warning" : "danger";
        if (remainingUsage <= 0) {
          barColor = "danger";
          remainingUsage = maxUsage;
        }
        dataUsage = (
          <div>
            <span className="progress-badge">Datos ({gigasString}GB)</span>
            <Progress value={remainingUsage} max={maxUsage} color={barColor}>
              {usageText}
            </Progress>
            <br />
          </div>
        );
      }
  
      let voiceUsage = undefined;
      if (mobile.minutos > 0) {
        let currentCDRType = "Llamadas";
        let currentCDR = CDR[currentCDRType];
        let usage = 0.0;
        if (currentCDR !== undefined) {
          usage = currentCDR[0].consumo;
        }
        let maxUsage = this.getMaxUsageByType(mobile, currentCDRType);
        let remainingUsage = this.remainingUsage(usage, currentCDRType, maxUsage);
        let usageText = this.getRemainingUsageTextByType(remainingUsage, currentCDRType);
        if (remainingUsage <= 0) remainingUsage = maxUsage;
        voiceUsage = (
          <div>
            <span className="progress-badge">Voz ({mobile.minutos} minutos)</span>
            <Progress value={remainingUsage} max={maxUsage} color={(remainingUsage/maxUsage > 0.75) ? "info" : (remainingUsage/maxUsage > 0.25) ? "warning" : "danger"}>
              {usageText}
            </Progress>
            <br />
          </div>
        );
      }
  
      if (dataUsage == undefined && voiceUsage == undefined) {
        usageCreated = (
          <div>
            <div className="text-center">
              <i className="now-ui-icons media-2_sound-wave" /> No hay registros todavía
            </div>
            <br />
          </div>
        );
      } else {
        usageCreated = (
          <div>
            {dataUsage}
            {voiceUsage}
          </div>
        );
      }
    } else {
      usageCreated = (
        <div>
          <div className="text-center">
            <i className="now-ui-icons arrows-1_refresh-69 spin" />
          </div>
          <br />
        </div>
      );

    }

    return usageCreated;
  }
  redirectTo(redirect) {
    this.props.history.push(redirect);
  }
  render() {
    if (this.state.toDashboard === true) {
      this.redirectTo("/dashboard");
      // return <Redirect to="/dashboard" />;
    }
    //if (this.props.mainState.ordersLoaded && !this.state.ordersChartReady && this.props.mainState.orders.length > 0) this.loadCustomersChart();
    let contentToDisplay = null;
    let mobilesToDisplay = [];
    let searchBulkCustomer = null;

    if (this.props.mainState.isSearchMobilesResult && !this.props.mainState.isSearchingMobiles && this.props.mainState.customersMobilesLoaded) {
      mobilesToDisplay = this.props.mainState.mobilesSearchResult[this.props.mainState.searchMobilesQuery];
    } else if (!this.props.mainState.isSearchMobilesResult && !this.props.mainState.isSearchingMobiles && this.props.mainState.customersMobilesLoaded) {
      mobilesToDisplay = this.props.mainState.customersMobilesRaw;
    }
    if (!mobilesToDisplay) mobilesToDisplay = [];

    if(/*this.props.mainState.customersMobilesLoaded &&*/ mobilesToDisplay.length > 0){
      //console.log("######## MOBILES TO DISPLAY #######");
      //console.log(mobilesToDisplay);
      contentToDisplay = 
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Lista de móviles</CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr className="text-primary">
                  {theadmobiles.map((prop, key) => {
                    if (key === theadmobiles.length - 1)
                      return (
                        <th key={key} className="text-center">
                          {prop}
                        </th>
                      );
                    return <th key={key} className="text-center">{prop}</th>;
                  })}
                </tr>
              </thead>
              <tbody>
                {mobilesToDisplay.map((currentMobile, key) => {
                  // console.log("####### TEST MOBILES #######");
                  // console.log(currentMobile);
                  //let servicesButtons = this.createServicesButtons(currentMobile);
                  //let activeCustomerButton = this.createActiveCustomerButton(currentMobile);
                  let currentCustomer = null;
                  let currentCustomerLink = currentMobile.nombre_completo;
                  let currentUsage = this.createUsage(currentMobile);
                  // if(currentMobile.cliente_id in this.props.mainState.customers) {
                  //   currentCustomer = this.props.mainState.customers[currentMobile.cliente_id][0];
                  // console.log("currentMobile fields", currentMobile);                  
                  if (!currentCustomerLink) {
                    currentCustomerLink = (
                        <Link
                          to={"/clientes/fichas/".concat(
                            currentMobile.cliente_id
                          )}
                        >
                          <span>
                            <i className="now-ui-icons arrows-1_refresh-69 spin" />
                            {"  Cargando..."}
                          </span>
                        </Link>
                      );
                  } else {
                    currentCustomerLink = 
                      <Link to={"/clientes/fichas/".concat(currentMobile.cliente_id)}>
                        {currentMobile.nombre_completo} {currentMobile.primer_apellido} {currentMobile.segundo_apellido}
                      </Link>;
                  }
                  // } else {
                  //   //if (!isSearchingCustomer) this.props.searchCustomer();
                  //   currentCustomerLink =                       
                  //     <div className="btns-mr-5">
                  //       <Button icon color="default" size="sm">
                  //         <i className="now-ui-icons arrows-1_refresh-69 spin reposition-spin" />
                  //       </Button>
                  //     </div>;
                  // }
                  let mobilePlan = currentMobile.plan ? currentMobile.plan.replace("(Nueva) ", "").replace(" (Móvil)", "") : "Error en tarifa";
                  let formattedNumber = currentMobile.numero.substring(0, 3) + " " + currentMobile.numero.substring(3, 6)
                    + " " + currentMobile.numero.substring(6, 9);
                  let customerDni = currentMobile.dni;
                  if (!customerDni) {
                    customerDni = (
                      <span>
                        <i className="now-ui-icons arrows-1_refresh-69 spin" />
                        {"  Cargando..."}
                      </span>
                    );
                  }
                  return (
                      <tr key={currentMobile.numero + "_" + key}>
                          <td className="text-center">
                            <Link to={"/clientes/fichas/".concat(currentMobile.cliente_id) + "/movil/" + currentMobile.numero}>
                              {formattedNumber}
                            </Link>
                          </td>
                          <td className="text-center">
                            {currentCustomerLink}
                          </td>
                          <td className="text-center">{currentMobile.dni}</td>
                          <td className="text-center">
                            {mobilePlan}
                          </td>
                          <td className="text-center">{currentMobile.precio}</td>
                          {/*<td className="text-center">{currentMobile.gigas.replace(".000", "") + " GB"}</td>
                          <td className="text-center">{currentMobile.minutos}</td>*/}
                          <td className="text-center">{currentUsage}</td>
                          {/* order.data.map((prop, key) => {
                            if (key === thead.length - 1)
                              return (
                                <td key={key} className="text-right">
                                  {prop}
                                </td>
                              );
                            return <td key={key}>{prop}</td>;
                          }) */}
                      </tr>
                  );
                })}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </Col>;
      if (searchBulkCustomer != null) {
        this.props.searchCustomer(this.searchMobiles);
      }    
    }else if(this.props.mainState.isSearchMobilesResult && this.props.mainState.customersMobilesLoaded && mobilesToDisplay.length == 0) {
      
      contentToDisplay = 
      <Col xs={12}>
        <Card>
          <CardHeader>
            <CardTitle tag="h4">Lista de clientes</CardTitle>
          </CardHeader>
          <CardBody>
            <Row>
              {/*<Label sm={2}>Buscar</Label>*/}
              <Col xs={12} sm={10}>
                No hay resultados para <b>{this.props.mainState.searchMobilesQuery}</b>...
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Col>;
    }else {
      contentToDisplay = 
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="¡Un momentito!"
          onConfirm={() => this.hideAlert()}
          showConfirm={false}
        >
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
            {"  Cargando móviles..."}
        </SweetAlert>;
    }

    let orderArticles = 
      <SweetAlert
        style={{ display: "block", marginTop: "-100px" }}
        title="Detalles de la factura"
        onConfirm={() => this.hideDetail()}
        showConfirm={true}
      >
        {this.state.orderDetail}
      </SweetAlert>;
    return (
      <div>
        <PanelHeader
          size="sm"
          /* content={
            <div className="header text-center">
              <h2 className="title">Lista de clientes</h2>
              {<p className="category"></p>}
            </div>
          }*/
        />
        <div className="content">
          <Row>
            <Col lg={3} md={6} xs={12}>
              <Card>
                <CardBody className="form-inline">
                  <Input type="text" 
                    placeholder="Buscar móvil..."
                    value={this.state.searchQuery}
                    onChange={(e) => this.handleChange("searchQuery", e)}
                    onKeyDown={e => {
                      //console.log(e.keyCode);
                      if(e.keyCode == 13){
                        //Enter is key code 13
                        this.searchMobiles();
                        // put the login here
                      }
                    }}
                    style={{marginRight:"10px"}}
                  />
                  <Button
                    color={
                      this.props.mainState.isSearchingMobiles
                        ? "default"
                        : "primary"
                    }
                    round 
                    icon 
                    onClick={this.searchMobiles}>
                <i className={this.props.mainState.isSearchingMobiles?
                                      "now-ui-icons arrows-1_refresh-69 spin reposition-spin" :"now-ui-icons ui-1_zoom-bold"} />
              </Button>
                </CardBody>
              </Card>
            </Col>
            {/*<Label sm={2}>Buscar</Label>*/}
          </Row>
          <Row>
            {this.state.showDetail && orderArticles}
            {contentToDisplay}
          </Row>
        </div>
      </div>
    );
  }
}

export default MobileList;



// WEBPACK FOOTER //
// ./src/views/Mobiles/MobilesList.jsx